export const FILE_TYPES = [
  { label: "TXT ( Pipe Separated)", value: "txtPipe", delimeter: "pipe" },
  { label: "CSV ( Comma Separated)", value: "csvComma", delimeter: "comma" },
];
